// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-06cd5442]{animation:spin-06cd5442 .75s linear infinite;height:48px;width:48px;will-change:transform}.spinner path[data-v-06cd5442]{transform-origin:center}.spinner--small[data-v-06cd5442]{height:24px;width:24px}.spinner--large[data-v-06cd5442]{height:64px;width:64px}@keyframes spin-06cd5442{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
